export default __webpack_public_path__ + "static/media/logo.90581f96.svg";